<template>
  <div
    class="item-service"
    @click="selectBox">

    <div class="post-image">

      <div class="position-absolute list-image">
        <div class="center-elements image-bg">
          <img
            v-if="image"
            width="100%"
            :src="image" />

          <div
            v-else
            class="camera-icon">

            <icon
              name="camera"
              scale="2" />

          </div>
        </div>

        <div
          v-if="isOferlayShown"
          :class="getOverlayClass">

          <div class="center-elements">
            <!-- Select post button -->
            <div
              v-if="selectable"
              class="post-selection-overlay text-center">

              <q-icon
                :allowSelfUpdate="false"
                :className="getConnectedClass"
                name="connected"
                width="45px"
                @click="selectBox" />

            </div>

            <!-- Edit post button -->
            <div
              v-if="editable"
              class="post-selection-overlay text-center buttons">

              <input-button
                class="mt-2 ml-2 mr-2"
                pointable
                hollow
                smaller
                variant="standardInput"
                btnStyle="ok-style"
                :inputPlaceholder="$t('Button.edit')"
                @click="editPost" />

              <input-button
                class="mt-2 ml-2 mr-2"
                pointable
                hollow
                smaller
                variant="standardInput"
                btnStyle="nok-style"
                :inputPlaceholder="$t('Button.remove')"
                @click="deletePost" />


            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="post-body">
      <div :class="getPostContentStyle">
        {{ title }}
      </div>
      
      <div :class="getPostPricingStyle">
        <p class="font-weight-bold">
          <span :class="{'float-right': true, 'ml-1': true}">
            <span :class="{'invalid-price': getDiscount.discount, 'price': !getDiscount.discount }">
              {{ getPrice }} 
              EUR
            </span>

            <span
              v-if="getDiscount.discount"
              class="price">

              {{ getDiscountedPrice }}
              EUR
            </span>
            
          </span>

          <span
            v-if="getDiscount.discount"
            class="discount-tag">

            {{ getAdvertisableDisplayDiscount }} 
          </span>

          <span
            v-if="getQuantity"
            class="float-right float-md-left ml-4">

            {{ getQuantity }}x
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import item from '@/mixins/service/postList/item'

export default {
  computed: {
    getPostPricingStyle () {
      let base = `post-pricing inlined`
      if (this.selected) {
        base = `selected ${base}`
      }
      return base
    }
  },

  mixins: [ item ]
}
</script>

<style scoped>
.overlay-shown {
  border: 1px solid #7AC143;
  border-right: none;
}
.icon-plain {
  position: relative;
  top: -200px;
  opacity: 0;
  transition: all .3s;
  width: 0;
  height: 0;
  overflow: hidden;
}
.raised {
  opacity: 1;
  top: 0;
  width: 45px;
  height: 45px;
}
.camera-icon {
  position: absolute;
  left: 20px;
  top: 20px;
  color: white;
}
.image-bg {
  background-color: #FFF;
  border: 1px solid #E3E3E3;

  background: rgba(248,248,248,1);
  background: -moz-linear-gradient(top, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(248,248,248,1)), color-stop(100%, rgba(53,54,53,1)));
  background: -webkit-linear-gradient(top, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  background: -o-linear-gradient(top, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  background: -ms-linear-gradient(top, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  background: linear-gradient(to bottom, rgba(248,248,248,1) 0%, rgba(53,54,53,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f8f8f8', endColorstr='#353635', GradientType=0 );
}
.overlay-bg {
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #00000077;
  opacity: 0;
  transition: opacity .3s;
}
.overlay-shown {
  opacity: 1;
}
.overlay-hover {
  opacity: 0;
  transition: opacity .3s;
}
.overlay-hover:hover {
  opacity: 1;
}
.center-elements {
  height: 100%;
  width: 100%;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  justify-content: center;
  margin: 0;
  position: relative;
}
.post-selection-overlay {
  position: relative;
}
.post-selection-overlay.buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.post-content, .post-pricing {
  position: relative;
  width: 180px;
  height: 90px;
  top: 180px;
  border: 1px solid #E3E3E3;
}
.post-content {
  top: 0;
  left: 179px;
  height: 135px;
  max-height: 135px;
  top: 0px;
  padding: 14px 20px;
  width: Calc(100% - 180px);
  border-bottom: 0;
  font-size: 12px;
  line-height: 17px;
  overflow-y: scroll;
}
.post-pricing {
  padding: 14px 20px;
  position: relative;
  font-size: 11px;
  height: 45px;
  top: 0;
  left: 179px;
  width: Calc(100% - 180px);
}
.selected.post-content, .selected.post-pricing {
  border: 1px solid #7AC143;
}
.selected.post-pricing {
  border-top: none;
}

.eur-synbol {
  margin-left: 5px;
}

.post-head {
  position: relative;
}
.content {
  padding: 20px;
}
.item-service {
  background-color: white;
  padding: 0;
  cursor: pointer;
}
.price {
  color: #1E1E1E!important;
  padding-top: 15px;
  height: 45px;
  max-height: 45px;
  overflow-y: scroll;
}
.invalid-price {
  text-decoration: line-through;
  color: #353635;
  font-weight: lighter;
  margin-right: 6px;
}
.discount-tag {
  border-radius: 0px 6px 6px 0px;
  color: #fff;
  display: block;
  float: right;
  padding: 3px 6px;
  background: #93274f;
  font-size: 12px;
  font-weight: 400;
  position: absolute;
  left: -179px;
  bottom: 10px;
  background-color:#7AC143;
}
.inlined {
  display: inline-block;
}
.list-image {
  width: 180px;
  height: 180px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .list-image {
    height: 69px;
    width: 83px;
  }

  .post-content {
    left: 82px;
    height: 69px;
    width: Calc(100% - 82px);
  }

  .post-pricing {
    width: 100%;
    left: 0;
    top: -1px;
  }

  .discount-tag {
    left: 0;
    bottom: 11px;
    padding: 3px 6px;
    font-size: 10px;
  }

  .icon-plain {
    top: 0;
    opacity: 1;
    width: 50px;
    cursor: pointer;
  }

  .post-selection-overlay {
    top: 0;
  }

  .raised {
    opacity: unset;
    top: unset;
    width: 25px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/service/postList/ItemList.vue?3920e53c